import React, { useContext } from 'react';
import { Route, Redirect } from 'react-router-dom';

import { StaticContext } from '@sm/webassets';

import { LocationProps, PricingRouteProps } from './types';

const UPGRADE_PATH = '/pricing/upgrade/';
const EDUCATIONAL_PATH = '/pricing/educational';

const PricingRoutes: React.FC<PricingRouteProps> = ({ redirectPath, path, ...rest }) => {
  const {
    user: { isEduQualified },
  } = useContext(StaticContext);

  const { search } = rest.location as LocationProps;
  // Only redirect to educational page on the base route(/pricing), and continue on with the same flow as before
  if (isEduQualified && path === '/pricing') {
    return <Redirect to={{ pathname: EDUCATIONAL_PATH, search }} />;
  }
  // Since we will eventually get rid of the upgrade path
  if (path?.includes(UPGRADE_PATH)) {
    if (isEduQualified) {
      return <Redirect to={{ pathname: EDUCATIONAL_PATH, search }} />;
    }
    return <Redirect to={{ pathname: redirectPath, search }} />;
  }
  return <Route {...rest} />;
};

export default PricingRoutes;
